import firebase from "firebase";

const config = {
  apiKey: "AIzaSyCDG1dhWGs8cc5jkE1gxge7AyNHMjiqc-Q",
  authDomain: "kempo-lp.firebaseapp.com",
  databaseURL: "https://kempo-lp.firebaseio.com",
  projectId: "kempo-lp",
  storageBucket: "kempo-lp.appspot.com",
  messagingSenderId: "184671878837",
  appId: "1:184671878837:web:44dc7e98fc0f139ebd08fc",
  measurementId: "G-GPLKS2RXFR"
};
firebase.initializeApp(config);
firebase.analytics();
export const functions = firebase.functions();
